import styled from 'styled-components';

export const InlineIcon = styled.div`
    display: flex;
    padding-right: 1em;
`;